import { type FC } from 'react';
import { graphql, useFragment } from 'react-relay';

import { PdpSharedBuyItNowButton } from './PdpSharedBuyItNowButton.tsx';
import { PdpSharedAddToCartButton } from './PdpSharedAddToCartButton.tsx';

import { type PdpSharedShoppingButtons_user$key } from './__generated__/PdpSharedShoppingButtons_user.graphql.ts';
import { type PdpSharedShoppingButtons_item$key } from './__generated__/PdpSharedShoppingButtons_item.graphql.ts';
import { type PdpSharedShoppingButtons_viewer$key } from './__generated__/PdpSharedShoppingButtons_viewer.graphql.ts';

const userFragment = graphql`
    fragment PdpSharedShoppingButtons_user on User {
        ...PdpSharedAddToCartButton_user
    }
`;

const itemFragment = graphql`
    fragment PdpSharedShoppingButtons_item on Item {
        ...PdpSharedBuyItNowButton_item
        ...PdpSharedAddToCartButton_item
    }
`;

const viewerFragment = graphql`
    fragment PdpSharedShoppingButtons_viewer on Viewer {
        ...PdpSharedAddToCartButton_viewer
    }
`;

export const PdpSharedShoppingButtons: FC<{
    user: PdpSharedShoppingButtons_user$key | null | undefined;
    item: PdpSharedShoppingButtons_item$key;
    viewer: PdpSharedShoppingButtons_viewer$key | null | undefined;
    skuId?: string;
    quantitySelected?: string;
}> = ({ user: userRef, item: itemRef, viewer: viewerRef, skuId, quantitySelected }) => {
    const user = useFragment(userFragment, userRef);
    const item = useFragment(itemFragment, itemRef);
    const viewer = useFragment(viewerFragment, viewerRef);

    return (
        <>
            <PdpSharedBuyItNowButton
                item={item}
                skuId={skuId}
                quantitySelected={quantitySelected}
            />
            <PdpSharedAddToCartButton
                user={user}
                item={item}
                viewer={viewer}
                skuId={skuId}
                quantitySelected={quantitySelected}
            />
        </>
    );
};
